import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./router";
import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { applyMiddleware, compose, createStore } from "redux";
import thunk from "redux-thunk";
import reducerIndex from "./reducers";
import { initializeFirebase } from "./pushNotification/pushNotification";
import { forceSWupdate } from "./constant/helper";

const appConfig = {
  direction: "rtl",
  // direction: "ltr",
};
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(
  reducerIndex,
  composeEnhancers(applyMiddleware(thunk))
);

// forced update
let params = new URLSearchParams(window.location.search);
if (params.has("update")) {
  let forcedUpdate = params.get("update");

  if (
    forcedUpdate &&
    (Boolean(forcedUpdate) === true || forcedUpdate === "true")
  ) {
    forceSWupdate();
  }
}

ReactDOM.render(
  <>
    <Provider store={store}>
      <ConfigProvider {...appConfig}>
        <Router>
          <App />
        </Router>
      </ConfigProvider>
    </Provider>
  </>,
  document.getElementById("root")
);

initializeFirebase(); // initialize Firebase
